import uiLibLocale from '@/locale';
const t = uiLibLocale.locale.t;
export { t };
